<template>
    <v-card>
        <v-card-text class="headline text-xs-center secondary--text">
            Insira seu SmartLock
        </v-card-text>
        <v-container grid-list-lg class="pt-0">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field
                    v-model="codigo"
                    label="Digite o seu codigo"
                    outline
                    :type="'password'"
                    :rules="[v => !!v || 'Insira um código válido']"
                    required
                    :min="4"
                    v-on:keyup.enter="autenticar"
                  />
                </v-flex>
            </v-layout>
        </v-container>
        <v-card-actions>
            <v-btn flat color="grey darken-2"  @click="fechar">
                CANCELAR
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="autenticar" flat color="green" :loading="loading">
                AUTENTICAR
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      codigo: null
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    fechar () {
      this.codigo = null
      this.$emit('fechar')
    },
    autenticar () {
      this.$store.dispatch('pinAutenticar', this.codigo).then(value => {
          if (value === 'ok') {
            this.$emit('autenticado')
          } else {
             alert(value)
          }
        })
    }
  }
}
</script>
